// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportActionBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var ActionButton = require('share/components/controls/Izenda.ActionButton');
  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var Button = require('share/components/controls/Izenda.Button');
  var Alert = require('share/components/controls/Izenda.Alert');

  var ImportActionBar = React.createClass({
    propTypes: {
      onCancel: React.PropTypes.func.isRequired,
      onImport: React.PropTypes.func.isRequired,
      alertMessage: React.PropTypes.object.isRequired
    },

    render: function () {
      var props = this.props;
      var localization = props.localization;
      var alertMessage = props.alertMessage;

      return (
        <div className="izenda-Wrapper-header">
          <IconMenu/>

          <Alert className='pull-left' type={alertMessage.type}>
            {alertMessage.message}
          </Alert>

          <div className='izenda-ActionBarRight'>
            <ActionButton><Button label={localization.getText("COMMON_LABEL_IMPORT")} onClick={props.onImport}></Button></ActionButton>
            <Button label={localization.getText("COMMON_LABEL_CANCEL")} onClick={props.onCancel} className='btn-report-default'></Button>
          </div>
        </div>
      );
    },
  });

  module.exports = connect()(ImportActionBar);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/DataModel/Izenda.ImportActionBar.jsx